(function () {
  "use strict";

  angular.module("partners").config(PartnersRoute);

  PartnersRoute.$inject = ["$stateProvider"];

  /* @ngInject */
  function PartnersRoute($stateProvider) {
    $stateProvider
      .state("root.partners", {
        abstract: true,
        url: "/partners",
        resolve: {
          /* Inserir as regras de Acl aqui! */
        },
      })
      .state("root.partners.list", {
        url: "/list",
        views: {
          "inner-view@root": {
            templateUrl: "templates/partners/list/list.html",
            controller: "ManagePartnersListController",
            controllerAs: "partnersList",
            resolve: {
              eventTypes: function () {
                return [
                  { id: "expo", name: "Expo" },
                  { id: "virtual_fair", name: "Virtual Fair" },
                ];
              },
              expos: function (ExpoService) {
                return ExpoService.getExposForSelect().then(
                  (response) => response.data
                );
              },
              virtualFairs: function (VirtualFairService) {
                return VirtualFairService.getAll().then(
                  (response) => response.data
                );
              },
              // partnersList: ['ManagePartnersService', function(ManagePartnersService) {
              //     return ManagePartnersService.getAll();
              // }],
            },
          },
        },
      })
      .state("root.partners.create", {
        url: "/create",
        views: {
          "inner-view@root": {
            templateUrl: "templates/partners/form/form.html",
            controller: "PartnerFormController",
            controllerAs: "partnerForm",
            resolve: {
              eventTypes: function () {
                return [
                  { id: "expo", name: "Expo" },
                  { id: "virtual_fair", name: "Virtual Fair" },
                ];
              },
              expos: function (ExpoService) {
                return ExpoService.getExposForSelect().then(
                  (response) => response.data
                );
              },
              virtualFairs: function (VirtualFairService) {
                return VirtualFairService.getAll().then(
                  (response) => response.data
                );
              },
            },
          },
        },
      })
      .state("root.partners.edit", {
        url: "/{id}/edit",
        views: {
          "inner-view@root": {
            templateUrl: "templates/partners/form/form.html",
            controller: "PartnerFormController",
            controllerAs: "partnerForm",
            resolve: {
              eventTypes: function () {
                return [
                  { id: "expo", name: "Expo" },
                  { id: "virtual_fair", name: "Virtual Fair" },
                ];
              },
              expos: function (ExpoService) {
                return ExpoService.getExposForSelect().then(
                  (response) => response.data
                );
              },
              virtualFairs: function (VirtualFairService) {
                return VirtualFairService.getAll().then(
                  (response) => response.data
                );
              },
            },
          },
        },
      })
      .state("root.partners.report-career-advisors", {
        url: "/report/career-advisors",
        views: {
          "inner-view@root": {
            templateUrl: "templates/partners/reports/career-advisors/list.html",
            controller: "ReportsCareerAdvisorsListController",
            controllerAs: "partnerReportsCareerAdvisors",
          },
        },
      })
      .state("root.partners.report-tsw", {
        url: "/tsw_report",
        views: {
          "inner-view@root": {
            templateUrl: "templates/partners/reports/tws/list.html",
            controller: "ReportsTwsListController",
            controllerAs: "partnerReports",
            resolve: {
              twsList: [
                "ReportsPartnersService",
                function (ReportsPartnersService) {
                  return ReportsPartnersService.getTswReport();
                },
              ],
            },
          },
        },
      })
      .state("root.partners.report-students", {
        url: "/report/students",
        views: {
          "inner-view@root": {
            templateUrl: "templates/partners/reports/students/list.html",
            controller: "ReportsStudentsListController",
            controllerAs: "partnersReportsStudents",
          },
        },
      })
      .state("root.partners.clients", {
        url: "/clients",
        views: {
          "inner-view@root": {
            templateUrl: "templates/partners/clients/list.html",
            controller: "ClientsPartnersListController",
            controllerAs: "clientsPartnersList",
            resolve: {
              partnersList: [
                "ClientsPartnersService",
                function (ClientsPartnersService) {
                  return ClientsPartnersService.getAll();
                },
              ],
            },
          },
        },
      })
      .state("root.partners.users", {
        url: "/users",
        views: {
          "inner-view@root": {
            templateUrl: "templates/partners/users/list.html",
            controller: "PartnerUserListController",
            controllerAs: "partnerUserList",
          },
        },
      })
      .state("root.partners.users.form", {
        url: "/form",
        views: {
          "inner-view@root": {
            templateUrl: "templates/partners/users/form/form.html",
            controller: "PartnerUserFormController",
            controllerAs: "partnerUserForm",
          },
        },
      });
  }
})();
